import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@material-ui/core';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';

import { Button } from '../../../../shared/components/Button';
import { Input } from '../../../../shared/components/Form/Input';
import { InputPassword } from '../../../../shared/components/Form/Input/InputPassword';
import { useSnackMessages } from '../../../../shared/hooks/useSnackMessages';
import { api } from '../../../../shared/services/apiClient';
import { PageAnimation } from '../../components/Animation/PageAnimation';
import { Header } from '../../components/Header';

const schema = yup.object().shape({
  name: yup.string().required('O nome é obrigatório.'),
  email: yup.string().required('O e-mail é obrigatório.'),
  password: yup
    .string()
    .required('A senha é obrigatória.')
    .min(6, 'No mínimo 6 caracteres.'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Confirmação incorreta'),
});

type FormValues = {
  name: string;
  email: string;
  password: string;
  password_confirmation: string;
};

function SignUp() {
  const history = useHistory();

  const { msgSuccess, msgError } = useSnackMessages();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
    mode: 'onChange',
  });

  const onSubmit = useCallback(
    async ({ name, email, password, password_confirmation }: FormValues) => {
      setLoading(true);

      try {
        await api.post('/register', {
          name,
          email,
          password,
          password_confirmation,
        });

        msgSuccess('Cadastrado com sucesso!');

        history.push('/sign-in');
      } catch (err: any) {
        setLoading(false);
        msgError(err?.response?.data?.message);
      }
    },
    [msgError, msgSuccess, history]
  );

  return (
    <PageAnimation>
      <Header
        title="Criar uma conta"
        link="/sign-in"
        linkName="Fazer login"
        mb={4}
      />

      <Box
        component="form"
        display="flex"
        flexDirection="column"
        gridGap={8}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Input
          name="name"
          control={control}
          error={errors}
          variant="outlined"
          label="Insira seu nome completo"
          fullWidth
          required
          disabled={loading}
        />
        <Input
          type="email"
          name="email"
          control={control}
          error={errors}
          variant="outlined"
          label="Insira seu e-mail"
          fullWidth
          required
          disabled={loading}
        />
        <InputPassword
          name="password"
          control={control}
          error={errors}
          variant="outlined"
          label="Digite sua senha"
          required
          disabled={loading}
        />
        <InputPassword
          name="password_confirmation"
          control={control}
          error={errors}
          variant="outlined"
          label="Repita sua senha"
          required
          disabled={loading}
        />

        <Button
          type="submit"
          loading={loading}
          disabled={loading}
          style={{ width: '100%' }}
        >
          Criar conta
        </Button>
      </Box>
    </PageAnimation>
  );
}

export { SignUp };
